import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useCategory = () => {
    return useQuery({
        queryKey: ['category'],
        queryFn: async () => {
            const res = await apiClient.get('/category/all');
            return res.data;
        }
    })
}